import { __extends } from "tslib";
import { BitmapImage2D } from "@awayjs/stage";
import { Timeline, MovieClip, Sprite, DisplayObjectContainer, TextField, DefaultSceneGraphFactory } from "@awayjs/scene";
import { getAVM1Object } from "./lib/AVM1Utils";
var AVM1SceneGraphFactory = /** @class */ (function (_super) {
    __extends(AVM1SceneGraphFactory, _super);
    function AVM1SceneGraphFactory(avm1Context) {
        var _this = _super.call(this) || this;
        _this.imageStore = {};
        _this.avm1Context = avm1Context;
        AVM1SceneGraphFactory._instance = _this;
        return _this;
    }
    Object.defineProperty(AVM1SceneGraphFactory, "instance", {
        get: function () {
            if (!AVM1SceneGraphFactory._instance) {
                console.log("Error. A instance of AVM1SceneGraphFactory must be created manually before accessing the singleton AVM1SceneGraphFactory._instance");
                //AVM1SceneGraphFactory._instance=new AVM1SceneGraphFactory();
            }
            return AVM1SceneGraphFactory._instance;
        },
        enumerable: true,
        configurable: true
    });
    AVM1SceneGraphFactory.prototype.createSprite = function (prefab) {
        if (prefab === void 0) { prefab = null; }
        return new Sprite();
    };
    AVM1SceneGraphFactory.prototype.createDisplayObjectContainer = function () {
        return new DisplayObjectContainer();
    };
    AVM1SceneGraphFactory.prototype.createMovieClip = function (timeline, symbol) {
        if (timeline === void 0) { timeline = null; }
        if (symbol === void 0) { symbol = null; }
        //var avm1MovieClip:AVM1MovieClip=<AVM1MovieClip>AVM1MovieClip.createAVM1Class(this.avm1Context)._ownProperties["prototype"].value;
        var awayMovieClip = new MovieClip(timeline || new Timeline());
        if (symbol.isButton) {
            var avm1Button = getAVM1Object(awayMovieClip, this.avm1Context);
        }
        else {
            var avm1MovieClip = getAVM1Object(awayMovieClip, this.avm1Context);
        }
        return awayMovieClip;
        /*
        for(let key in timeline.avm1InitActions){
            console.log("\n\nfound init actions\n\n", timeline.avm1InitActions[key]);
            //this._addAvm1InitActionBlocks(frameIndex, initActionBlocks);
        }
        for(let key in timeline.avm1Exports){
            console.log("\n\nfound export\n\n", timeline.avm1Exports[key]);
            for(let i:number=0; i<timeline.avm1Exports[key].length; i++){
                let asset=timeline.avm1Exports[key][i];
                //this.avm1Context.addAsset(asset.className, asset.symbolId, null);
            }
            //this._addAvm1InitActionBlocks(frameIndex, initActionBlocks);
        }
        */
        /*
        
                    if(frames[i].initActionBlocks){
                        awayTimeline.avm1InitActions[i]=frames[i].initActionBlocks;
                    }
                    if(frames[i].exports){
                        awayTimeline.avm1Exports[i]=frames[i].exports;
                    }
                if (frameInfo.exports) {
                    var exports = frameInfo.exports;
                    for (var i = 0; i < exports.length; i++) {
                        var asset = exports[i];
                        avm1Context.addAsset(asset.className, asset.symbolId, null);
                    }
                }
        
                var initActionBlocks = frameInfo.initActionBlocks;
                if (initActionBlocks) {
                    this._addAvm1InitActionBlocks(frameIndex, initActionBlocks);
                }*/
        //return awayMovieClip;
    };
    AVM1SceneGraphFactory.prototype.createTextField = function () {
        var awayTextfield = new TextField();
        awayTextfield.multiline = true;
        awayTextfield.wordWrap = true;
        var avm1textField = getAVM1Object(awayTextfield, this.avm1Context);
        return awayTextfield;
    };
    AVM1SceneGraphFactory.prototype.createBillboard = function (material) {
        return null; //new Billboard();
    };
    AVM1SceneGraphFactory.prototype.createImage2D = function (width, height, transparent, fillColor, powerOfTwo) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = null; }
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        return new BitmapImage2D(width, height, transparent, fillColor, powerOfTwo);
    };
    return AVM1SceneGraphFactory;
}(DefaultSceneGraphFactory));
export { AVM1SceneGraphFactory };
